export const environment = {
  production: true,
  apiBaseUrl: 'https://83jl680a29.execute-api.us-east-1.amazonaws.com/prod',
  wsApiBaseUrl: 'https://e8z9446nwg.execute-api.us-east-1.amazonaws.com/prod',
  // Facturas
  facturasUrl: 'https://app.stupendo.ec/receiver/login',
  // Soporte
  soporteEmail: 'pedidosb2b@cotopaxi.com.ec',
  soportePhone: '593993992059',
  buildVersion: '',
  buildSource: 'remote',
  buildEnvironment: 'production'
};
